//import { Progress } from "@/components/ui/progress";

import useMapStore from "@/store/mapStore";
//import { StepModel } from "./PoiDetailsSteps";*/
import PoiDetailsDistance from "./PoiDetailsDistance";
import ProgressBarWithTicks from "./ui/progress-ticks";
import { cn } from "@/lib/utils";

function PoiDetailsRouteProgress() {
  /*const mobileMode = useMapStore((state) => state.mobileMode);
  const routeDetails = useMapStore((state) => state.routeDetails);
  const currentStep = useMapStore((state) => state.currentStep) + 1;
  const stepsNumber = (routeDetails.TBTNav.steps as StepModel[]).filter((i) => {
    const direction = i.direction.split("_")[0];
    if (
      (i.levelChangerId && (direction === "UP" || direction === "DOWN")) ||
      i.direction === "FINISH"
    ) {
      return i;
    }
  }).length;*/
  const stops = useMapStore((state) => state.stops);
  const activeStop = useMapStore((state) => state.activeStop);
  // const setActiveStop = useMapStore((state) => state.setActiveStop);

  return (
    <div className={cn("w-full", stops.length > 2 && "mb-2 lg:mb-5")}>
      <PoiDetailsDistance className="mb-2" />
      {stops.length > 2 && (
        <ProgressBarWithTicks
          stops={stops}
          activeStop={activeStop}
          // onTickClick={setActiveStop}
        />
      )}
      {/*<Progress
        value={Math.trunc(
          ((currentStep ? currentStep : 1) / (stepsNumber ? stepsNumber : 1)) *
            100,
        )}
        mobileMode={mobileMode}
      />*/}
    </div>
  );
}

export default PoiDetailsRouteProgress;
